<template>
    <v-row class="pa-0 transition-all option" >
        <v-col cols="2" class="px-0">
            <v-img
                src="/img/user/soundicon.svg"
                max-height="45px"
                max-width="45px"
                contain
                class="main-sound-img ml-5 cursor-pointer"
                @click="readText(isReading ? answer.content : answer.contenido)"
            ></v-img>
        </v-col>
        <v-col
            data-cy="questionItem-item-selection"
            cols="9"
            :key="'radio-' + question.id + '-' + answer.id"
            :id="answer.id"
            v-ripple
            :class="styles"
            @click="setSelectedBtn"
            elevation="0"
        >
        <span
        >{{ $utils.capitalizeWord(isReading ? answer.content : answer.contenido) }}</span>
        </v-col>
    </v-row>
</template>

<script>
    import SpeechSynthesis from "../../../../mixins/SpeechSynthesis";
    import initialReaderValidation from "../../../../mixins/InitialReaderValidation";
    export default {
        name: "TextOption",
        props: {
            answer: {type: Object, default: () => ({})},
            question: {type: Object, default: () => ({})},
            selected: {type: Boolean, default: () => ({})},
            isReading: {type: Boolean, default: false},
            correct: {type: Boolean, default: false},
            incorrect: {type: Boolean, default: false},
        },
        computed: {
            styles() {
                return `alternative w-100 my-3 mx-2 overflow-hidden transition-all ${this.isInitialReader ? 'text-h5': 'text-h6'} cursor-pointer pa-2 border-radius-1 text-none option-btn pa-0
                ${this.colorForOption}`
            },
            colorForOption(){
                if(this.correct) return 'correct white--text';
                if(this.incorrect) return 'incorrect white--text';
                if(this.selected) return 'primary white--text';

                return 'white primary--text'
            },
        },
        data() {
            return {
                btnSelected: {
                    id: null,
                    value: null,
                    secret: null,
                },
            }
        },
        methods: {
            setSelectedBtn() {
                this.$emit('select', {
                    id: this.answer.id,
                    value: this.answer.id,
                    secret: this.answer.item,
                })
            },
        },
        mixins: [SpeechSynthesis, initialReaderValidation]
    }
</script>

<style scoped>
    .option-img {
        width: 100%;
        height: 100%;
        display: block;
        box-sizing: border-box;
    }
</style>
